import { put, call, takeLatest } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TUpdateGlobalAndProductSettingsReduxParams } from '~types/feat/setting';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateAdminSettings(api: SettingGateway): SagaWatcherReturnType {
    yield takeLatest('setting/settingCreateAdminSettingsAttempt', handleCreateAdminSettings, api);
}

function* handleCreateAdminSettings(api: SettingGateway, data: PayloadAction<TUpdateGlobalAndProductSettingsReduxParams>) {
    const state = store.getState();
    const authToken = state.auth.userDetails.authToken;

    const response = yield* call([api, api.createAdminSettings], { authToken, ...data.payload });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingCreateAdminSettingsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingCreateAdminSettingsSuccess());
        yield put(combinedActions.settingSetProductSettingCreateProductModalIsOpen(false));
        yield put(combinedActions.settingGetSettingsAttempt());
        toast.success(SuccessMessages.SettingUpdateSettingsSuccess);
    }
}
